function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.50926 1.32621C7.67783 0.870652 8.32217 0.870651 8.49074 1.32621C9.55072 4.19076 11.8092 6.44928 14.6738 7.50926C15.1293 7.67783 15.1293 8.32217 14.6738 8.49074C11.8092 9.55072 9.55072 11.8092 8.49074 14.6738C8.32217 15.1293 7.67783 15.1293 7.50926 14.6738C6.44928 11.8092 4.19076 9.55072 1.32621 8.49074C0.870651 8.32217 0.870651 7.67783 1.32621 7.50926C4.19076 6.44928 6.44928 4.19076 7.50926 1.32621Z",
  fill: "url(#paint0_linear_1817_1052)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1817_1052",
  x1: -1.42228e-7,
  y1: 8,
  x2: 33.7528,
  y2: -1.62935,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5BCCF1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#6F6AEB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.495,
  stopColor: "#9D42AA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.722341,
  stopColor: "#E95629"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#F99046"
})));

function SvgAiStar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStar1);
export default __webpack_public_path__ + "static/media/AiStar1.9be656bc.svg";
export { ForwardRef as ReactComponent };